import { CompactRecordList } from '../components/record-list.js';
import { Card, cn, PageHeader } from '../components/ui.js';
import { WelcomeCard } from '../help/welcome.js';
import { findEntity, useAppMeta } from '../lib/meta.js';
import { useSlot } from '../lib/slots.js';

/** Home: what needs attention across sales and operations, then the client's own cards. */
export function Dashboard() {
  const meta = useAppMeta();
  const cards = useSlot('app.dashboard');
  const can = (id: string) => Boolean(findEntity(meta, id));
  const firstName = meta.user.name.split(' ')[0] ?? meta.user.name;
  return (
    <>
      <PageHeader title={`Hello, ${firstName}`} subtitle={meta.organization.name} />
      <WelcomeCard />
      <div className="grid gap-5 lg:grid-cols-2">
        {can('crm.opportunity') && (
          <Card title="Open opportunities">
            <CompactRecordList
              entity="crm.opportunity"
              stateCategory={['open']}
              sort={{ field: 'expected_close', dir: 'asc' }}
              fields={['party_id', 'stage']}
              aside="amount"
              empty="No open opportunities"
            />
          </Card>
        )}
        {can('erp.invoice') && (
          <Card title="Invoices awaiting payment">
            <CompactRecordList
              entity="erp.invoice"
              filter={[{ field: 'state', op: 'in', value: ['issued', 'partly_paid'] }]}
              sort={{ field: 'due_date', dir: 'asc' }}
              fields={['party_id', 'due_date', 'state']}
              aside="amount_due"
              empty="Nothing outstanding"
            />
          </Card>
        )}
        {can('crm.activity') && (
          <Card title="Your activities">
            <CompactRecordList
              entity="crm.activity"
              stateCategory={['open']}
              filter={[{ field: 'owner_id', op: 'eq', value: meta.user.id }]}
              sort={{ field: 'due_at', dir: 'asc' }}
              fields={['kind', 'due_at', 'party_id']}
              empty="Nothing due"
            />
          </Card>
        )}
        {can('crm.lead') && (
          <Card title="New leads">
            <CompactRecordList
              entity="crm.lead"
              filter={[{ field: 'state', op: 'eq', value: 'new' }]}
              sort={{ field: 'created_at', dir: 'desc' }}
              fields={['company_name', 'source']}
              aside="score"
              empty="No new leads"
            />
          </Card>
        )}
        {cards.map((card) => (
          <Card key={card.id} title={card.title} className={cn(card.wide && 'lg:col-span-2')}>
            <card.component />
          </Card>
        ))}
      </div>
    </>
  );
}
